import { render } from "./EditMedicationClassDialog.vue?vue&type=template&id=03cf6c46"
import script from "./EditMedicationClassDialog.vue?vue&type=script&lang=js"
export * from "./EditMedicationClassDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__